
import { defineComponent } from "vue";

import BadgePrimary from "~/vue/atoms/badges/BadgePrimary.vue";
import ConsentHidden from "~/vue/organisms/consents/ConsentHidden.vue";
import ViewLocations from "~/vue/organisms/views/ViewLocations.vue";

export default defineComponent({
	components: {
		"badge--primary": BadgePrimary,
		"consent--hidden": ConsentHidden,
		"view--locations": ViewLocations,
	},
});
